<template>
    <div class="w-full flex flex-row items-end h-full py-2 text-gray-700 overflow-x-scroll">
        <div v-for="(tab, key, index) in tabList" :key="key" :index="index" :class="tab.class ? tab.class : 'h-full flex items-end  hover:text-dark-secondary'">
            <div v-if="tab.enabled==false" class="h-full flex flex-col">
                <div :class="tab.disabledClass ? tab.disabledClass : 'whitespace-nowrap tracking-widest text-gray-500 bg-gray-200 h-full px-3 flex items-center rounded-sm border-r border-gray-200'">
                    <div  class="">
                        {{ tab.label }}
                    </div>
                </div>
                <!-- <div class="h-1 bg-dark-secondary"></div> -->
            </div>
            <div v-else-if="tab.isSelected"  @mouseenter="unHighlightTab()" @mouseout="unHighlightTab()" @click="setTab(key)" class="cursor-pointer h-full flex flex-col ">
                <div :class="tab.selectedClass ? tab.selectedClass : 'whitespace-nowrap tracking-widest bg-indigo-0 text-white h-full px-3 flex items-center rounded-sm bg-dark-secondary active:bg-dark-primary border-r border-gray-200'">
                    <div  class="">
                        {{ tab.label }}
                    </div>
                </div>
                <!-- <div class="h-1 bg-dark-secondary"></div> -->
            </div>
            <div v-else @mouseover="highlightTab(index)" @mouseout="unHighlightTab()" @click="setTab(key)"  class="cursor-pointer h-full flex flex-col ">
                <div v-if="index==highlightedTabIndex" class="h-full flex flex-col">
                    <div :class="tab.highlightClass ? tab.highlightClass : 'whitespace-nowrap tracking-widest h-full px-3 flex items-center bg-gray-200 border-r border-gray-200 rounded-t-sm'">
                        <div class="">
                            {{ tab.label }}
                        </div>
                    </div>
                    <!-- <div class="h-1 bg-gray-300"></div> -->
                </div>
                <div v-else class="h-full flex flex-col">
                    <div :class="tab.unhighlightClass ? tab.unhighlightClass : 'whitespace-nowrap tracking-widest h-full px-3 flex items-center border-r border-gray-300'">
                        <div class="">
                            {{ tab.label }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, defineProps, defineEmits, computed } from 'vue';

const props = defineProps(['tabList'])
const emit = defineEmits(['set-tab'])

const highlightedTabIndex = ref(null)

function setTab(tabKey) {
    emit('set-tab', tabKey)
}


function highlightTab(index) {
    highlightedTabIndex.value = index
}

function unHighlightTab() {
    // console.log('unHighlightTab')
    highlightedTabIndex.value = null
}

</script>

<style scoped>
::-webkit-scrollbar {
  height: 0px;
  width: 0px;      
}
</style>